// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageCarouselStyles } from "@vanmeter/Overrides/Components/ProductImageCarousel";
import { mergeWithCss } from "@vanmeter/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
import { IconWrapper } from "@insite/mobius/Icon";

export const getImageCss = (selected: boolean) => css`
    width: 100%;
    height: 100%;
    max-width: 52px;
    max-height: 52px;
    border: 1px solid ${getColor("common.ui16")};
    cursor: pointer;
    justify-content: flex-start;
    ${!selected &&
    css`
        opacity: 0.5;
    `}
    img {
        max-width: 100%;
        max-height: 100%;
        aspect-ratio: 1;
        height: auto;
    }
`;

productImageCarouselStyles.container = {
    css: css`
        max-width: 100%;
        overflow: hidden;
        margin-top: 12px;

        @media print {
            display: none;
        }
    `,
};

productImageCarouselStyles.image = {
    css: getImageCss(false),
};

productImageCarouselStyles.selectedImage = {
    css: getImageCss(true),
};

productImageCarouselStyles.carouselStyle = {
    container: {
        css: css`
            display: flex;
            &&&& {
                ${IconWrapper} {
                    width: 40px;
                    height: 40px;
                    svg {
                        width: 40px;
                        height: 40px;
                    }
                }
            }
        `,
    },
    // container: {
    //     css: css`
    //         .carousel-scroll-bar {
    //             margin-bottom: 0;
    //         }
    //     `,
    // },
};

productImageCarouselStyles.carouselSlideInner = {
    ...mergeWithCss(productImageCarouselStyles.carouselSlideInner, {
        css: css`
            max-width: 52px;
            min-width: 52px;
            padding: 0;
        `,
    }),
};

productImageCarouselStyles.imageLink = {
    css: css`
        ${({ isSelected }: any) => !isSelected && `opacity:0.5`};
        height: 52px;
        width: 52px;
        .image-skeleton {
            min-width: 52px;
        }
    `,
};
